import { useMemo } from 'react'

import { useSelector } from 'react-redux'
import { Alert, Collapse, List, Switch, Tooltip } from 'antd'

import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import { selectUser } from '../../reducers/UserReducer'
import PremiumIcon from '../shared/Icons/PremiumIcon'

const SchoolOptionTable = ({ columns, density, schoolOptions, switchSchoolOption }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const isPremiumSchool = user.school?.premium === true

  const options = useMemo(() => schoolOptions.data.sort((a, b) => {
    return (
      t(`school_option.category.${a.optionType.category}`).localeCompare(t(`school_option.category.${b.optionType.category}`)) ||
        t(`school_option.type.${a.optionType.type}`).localeCompare(t(`school_option.type.${b.optionType.type}`))
    )
  }).reduce((acc, option) => {
    const optionType = option.optionType

    if (!optionType.isHidden) {
      const optionCategory = optionType.category

      if (!acc.optionsByCategory[optionCategory]) {
        acc.optionsByCategory[optionCategory] = []
      }

      acc.optionsByCategory[optionCategory].push(option)
      acc.optionTypesMap[optionType.id] = option.optionEnabled
      acc.hasPremiumOptions = acc.hasPremiumOptions || optionType.isPremium
    }

    return acc
  }, { optionsByCategory: {}, optionTypesMap: {}, hasPremiumOptions: false }), [schoolOptions.data, t])

  return (
    <div className='options-table'>
      {schoolOptions.loading && (
        <div className='center'>
          <div className='loading-icon black' />
        </div>
      )}
      {!schoolOptions.loading && !isPremiumSchool && options.hasPremiumOptions && (
        <Alert className='mb-16' type='info' showIcon icon={<PremiumIcon />} message={t('school_option.premium_upsell')} />
      )}
      {!schoolOptions.loading && schoolOptions.data.length > 0 && (
        <Collapse>
          {Object.keys(options.optionsByCategory).map(category => (
            <Collapse.Panel header={t(`school_option.category.${category}`)} key={category}>
              <List>
                {options.optionsByCategory[category].map(option => {
                  const premiumLocked = option.optionType.isPremium && !isPremiumSchool

                  return (
                    <List.Item key={option.optionType.id}>
                      <div>
                        {option.optionType.isPremium && (<PremiumIcon className='pdr-4' />)}
                        <span style={{ marginRight: '10px' }}>{t(`school_option.type.${option.optionType.type}`)}</span>
                      </div>
                      <Tooltip title={premiumLocked ? t('school_option.premium_upsell') : undefined}>
                        <Switch
                          disabled={!option.optionType.isEditable || premiumLocked}
                          checked={option.optionEnabled}
                          onChange={() => switchSchoolOption(option, {
                            optionType: option.optionType.type,
                            optionEnabled: !option.optionEnabled
                          })}
                        />
                      </Tooltip>
                    </List.Item>
                  )
                })}
              </List>
            </Collapse.Panel>
          ))}
        </Collapse>
      )}
      {!(schoolOptions.loading || schoolOptions.data.length > 0) && (
        <span> {t('No data is currently available for this page.')} </span>
      )}
    </div>)
}

export default SchoolOptionTable
